import { Content, HiddenContent, Item, Wrapper } from "./styles";
import React, { useEffect, useRef, useState } from "react";
import { ArrowDown } from "../../components/PopupMenu/styles";
import { StyledPrefix } from "../../components/MultiSelect/styles";

interface IAccordionItem {
  title: string;
  content: string;
}

const AccordionItem: React.FC<IAccordionItem> = ({ content, title }) => {
  const [open, setOpen] = useState<boolean>(false);

  const ref = useRef<any>(null);

  return (
    <Wrapper>
      <Item onClick={() => setOpen(!open)} open={open} id="bold">
        {title}
        <StyledPrefix>
          <ArrowDown size="2em" up={open} />
        </StyledPrefix>
      </Item>
      <HiddenContent ref={ref}>{content}</HiddenContent>
      <Content open={open} height={ref.current?.offsetHeight}>
        {content}
      </Content>
    </Wrapper>
  );
};

interface IAccordion {
  questions: IAccordionItem[];
}

export const Accordion: React.FC<IAccordion> = ({ questions }) => {
  return (
    <div>
      {questions.map((item, index) => (
        <AccordionItem key={index} {...item} />
      ))}
    </div>
  );
};
